import { render, staticRenderFns } from "./SecureInbox.vue?vue&type=template&id=42a83d20&"
import script from "./SecureInbox.vue?vue&type=script&lang=js&"
export * from "./SecureInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports